import axios from 'axios'
import router from '@/router'
const baseUrl = `${process.env.VUE_APP_AUTH_BASE_URL}/auth/login`

export const state = () => ({
  token: null,
  user: null
})

export const getters = {
  token (state) {
    return state.token
  },
  authenticated (state) {
    return state.token !== null
  },
  user (state) {
    return state.user
  },
  roles (state) {
    return state.user.roles
  }
}

export const actions = {
  async logout ({ commit, state }) {
    // console.log(`loggingout`)
    try {
      await axios.delete(baseUrl, {
        headers: {
          Authorization: `Bearer ${state.token}`
        }
      })
    } catch (error) {
      // console.log(`error logging out`)
      // console.error(error)
    } finally {
      commit('logout')
      commit('snapshots/clear', null, { root: true })
      router.push('/login')
    }
  }
}

export const mutations = {
  login (state, loginResult) {
    Object.assign(state, loginResult)
  },
  logout (state) {
    Object.assign(state, { token: null, user: null })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
